import React, { useEffect, useState } from 'react';

function Feedback() {
  const [modalShown, setModalShown] = useState(false);
  const [lanjutEnabled, setLanjutEnabled] = useState(false);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const storageKey = 'modalShown_' + currentPath;
    const oneYear = 1000 * 60 * 60 * 24 * 180;

    const lastShown = localStorage.getItem(storageKey);
    const now = new Date().getTime();

    if (!lastShown || now - parseInt(lastShown) > oneYear) {
      // setModalShown(true);
      localStorage.setItem(storageKey, now.toString());
    }
    setModalShown(true);
  }, []);

  const handleSubscribe = () => {
    setLanjutEnabled(true);
  };

  const handleLanjut = () => {
    alert('Terima kasih sudah Follow! Melanjutkan...');
    setModalShown(false);
  };

  return (
    <div className="container-fluid p-0" style={{ height: '100vh' }}>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSd2nxi2CxIwTbUEHCOXTnwJZ6N3QubOuGV8CqvqJC9Bepj_cQ/viewform?embedded=true"
        title="Feedback Form"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        allowFullScreen
      >
        Memuat…
      </iframe>

      {/* Modal */}
      {modalShown && (
        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Follow Instagram</h5>
              </div>
              <div className="modal-body text-center">
                <p><strong>Jangan lewatkan informasi penting dari kami!</strong></p>
              <p>Untuk mendapatkan update terbaru seputar <strong>webinar, commnutity gathering, dan event</strong>, 
                silakan <strong>Follow</strong> <strong>Instagram</strong> <strong>@conexsee</strong>.</p>
                <a
                  href="https://www.instagram.com/webinarconexsee/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-danger mb-3"
                  onClick={handleSubscribe}
                >
                  Follow Instagram
                </a>
                <br />
                <button
                  className="btn btn-primary"
                  onClick={handleLanjut}
                  disabled={!lanjutEnabled}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Feedback;
